import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-57a1f2e3")
const _hoisted_1 = { class: "pb-16" }
const _hoisted_2 = {
  key: 0,
  class: "fireworks"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "before" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "after" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "container mx-auto" }
const _hoisted_7 = { class: " mt-[40px] w-full items-center self-center" }
const _hoisted_8 = { class: "steps flex justify-between " }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "progress-bar mt-[32px] h-[2px] rounded-[24px] w-full" }
const _hoisted_11 = { class: "container mx-auto" }
const _hoisted_12 = { class: "card flex flex-wrap mt-[60px]" }
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "stats-header flex-none" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "My pool balance")
  ])
], -1)
const _hoisted_15 = { class: "stats flex-1" }
const _hoisted_16 = { class: " flex-1 justify-center" }
const _hoisted_17 = { class: "header flex" }
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Go back")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "flex-1 title text-center" }, " Withdraw from pool ", -1)
const _hoisted_21 = { class: "flex-1 text-right" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Exit ")
const _hoisted_23 = { class: "m-[24px] nested-card mt-[16px] max-w-[480px] mx-auto" }
const _hoisted_24 = { class: "nested-card mt-[16px]" }
const _hoisted_25 = {
  key: 2,
  class: "text-center finished"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mt-[70px] mb-5 mx-auto",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M62.5 32C62.5 36.0053 61.7111 39.9714 60.1783 43.6718C58.6456 47.3723 56.3989 50.7346 53.5668 53.5668C50.7346 56.3989 47.3723 58.6456 43.6718 60.1783C39.9714 61.7111 36.0053 62.5 32 62.5C27.9947 62.5 24.0286 61.7111 20.3282 60.1783C16.6277 58.6456 13.2654 56.3989 10.4332 53.5668C7.60106 50.7346 5.35444 47.3723 3.82167 43.6718C2.28891 39.9714 1.5 36.0053 1.5 32C1.5 27.9947 2.28891 24.0286 3.82168 20.3282C5.35444 16.6277 7.60106 13.2654 10.4332 10.4332C13.2654 7.60105 16.6277 5.35444 20.3282 3.82167C24.0286 2.2889 27.9947 1.5 32 1.5C36.0053 1.5 39.9714 2.28891 43.6718 3.82168C47.3723 5.35444 50.7346 7.60106 53.5668 10.4332C56.3989 13.2654 58.6456 16.6277 60.1783 20.3282C61.7111 24.0286 62.5 27.9947 62.5 32L62.5 32Z",
    stroke: "#BDB2DD",
    "stroke-width": "3",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M32.5 20C32.1867 20 31.8984 20.1422 31.6602 20.4007L23.3384 28.9822C23.1002 29.2536 23 29.525 23 29.8223C23 30.4685 23.4511 30.9596 24.0778 30.9596C24.366 30.9596 24.6669 30.8433 24.8674 30.6365L27.7249 27.7544L31.5726 23.3861L31.372 26.5267V42.8626C31.372 43.5347 31.8483 44 32.5 44C33.1517 44 33.6155 43.5347 33.6155 42.8626V26.5267L33.4275 23.399L37.2751 27.7544L40.12 30.6365C40.3331 30.8563 40.6214 30.9596 40.9222 30.9596C41.5363 30.9596 42 30.4685 42 29.8223C42 29.525 41.8872 29.2407 41.624 28.9564L33.3397 20.4007C33.089 20.1422 32.8008 20 32.5 20Z",
    fill: "#BDB2DD"
  })
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h1", null, "Success!", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", null, "Your withdrawal is completed!", -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Return to pool ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvestHero = _resolveComponent("InvestHero")!
  const _component_TickIcon = _resolveComponent("TickIcon")!
  const _component_QuestionIcon = _resolveComponent("QuestionIcon")!
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_PoolUserStats = _resolveComponent("PoolUserStats")!
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StakeView = _resolveComponent("StakeView")!
  const _component_WithdrawForm = _resolveComponent("WithdrawForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.activeStep==_ctx.steps.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_InvestHero, {
        step: _ctx.activeStep,
        headline: _ctx.steps[_ctx.activeStep-1].headline
      }, null, 8, ["step", "headline"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
              return (_openBlock(), _createElementBlock("button", {
                onClick: ($event: any) => (_ctx.clickActiveStep(step.step)),
                class: "self-start"
              }, [
                (step.step<_ctx.activeStep || _ctx.activeStep==_ctx.steps.length)
                  ? (_openBlock(), _createBlock(_component_TickIcon, {
                      key: 0,
                      class: _normalizeClass(["", {'block mx-auto':_ctx.isMobile,'mr-1 inline':_ctx.isDesktop}])
                    }, null, 8, ["class"]))
                  : (_openBlock(), _createBlock(_component_QuestionIcon, {
                      key: 1,
                      class: _normalizeClass(["", {'block mx-auto':_ctx.isMobile,'mr-1 inline':_ctx.isDesktop}])
                    }, null, 8, ["class"])),
                _createTextVNode(" " + _toDisplayString(step.button), 1)
              ], 8, _hoisted_9))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "progress absolute bottom-0 left-0 h-[2px] w-0 rounded-[24px] bg-styling-teal opacity-80 transition duration-300 ease-linear dark:bg-styling-teal",
              style: _normalizeStyle({ width: `${(_ctx.progressPerc() * 100).toFixed(0)}%` })
            }, null, 4)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                (_ctx.loadingPool || !_ctx.transfersAllowed || !_ctx.sorReady)
                  ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                      key: 0,
                      class: "h-96"
                    }))
                  : (_openBlock(), _createBlock(_component_PoolUserStats, {
                      key: 1,
                      pool: _ctx.pool,
                      xpolarToClaim: `0`,
                      dailyAPR: `1`,
                      stakedBalance: _ctx.stakedBalance
                    }, null, 8, ["pool", "stakedBalance"]))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "back actions",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
              }, [
                (_ctx.activeStep<5)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_ArrowLeftIcon, { class: "ml-3 mr-[12px] inline" }),
                      _hoisted_19
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_router_link, {
                class: "actions",
                to: { name: 'pool', params: { id: _ctx.id} }
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createVNode(_component_CloseIcon, { class: "inline ml-[12px]" })
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (_ctx.activeStep==2)
                ? (_openBlock(), _createBlock(_component_StakeView, {
                    key: 0,
                    unstake: true,
                    balance: _ctx.balanceFor(_ctx.pool?.address!),
                    token: ``,
                    address: _ctx.pool?.address,
                    onUunstakeConfirmed: _ctx.handleUnstakeConfirmed
                  }, null, 8, ["balance", "address", "onUunstakeConfirmed"]))
                : _createCommentVNode("", true),
              (_ctx.activeStep>=3 && _ctx.activeStep<=4)
                ? (_openBlock(), _createBlock(_component_WithdrawForm, {
                    key: 1,
                    step: _ctx.activeStep,
                    pool: _ctx.pool!,
                    onPreview: _ctx.handleLPPreview,
                    onConfirmWithdraw: _ctx.handleWithdrawConfirm
                  }, null, 8, ["step", "pool", "onPreview", "onConfirmWithdraw"]))
                : _createCommentVNode("", true),
              (_ctx.activeStep==5)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28,
                    _createVNode(_component_router_link, {
                      class: "exit inline-block mt-[20px]",
                      to: { name: 'pool', params: { id: _ctx.id } }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}